import React from "react";
import { Link } from "react-router-dom";

export default function QuienesSomos() {
  return (
    <div className="max-w-4xl mx-auto p-6 mt-6">
      {/* Breadcrumb */}
      <div className="mb-4 text-sm text-gray-600">
        <Link to="/" className="text-sky-600 hover:underline">
          Inicio
        </Link>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-800 font-medium">¿Quiénes somos?</span>
      </div>

      {/* Contenido */}
      <div className="bg-white shadow rounded p-6">
        <h2 className="text-2xl font-bold text-sky-800 mb-4">¿Quiénes somos?</h2>
        <p className="text-gray-600">
          Somos una empresa comprometida con ofrecer productos únicos, hechos con pasión y excelencia.
          Nuestro objetivo es brindar una experiencia inolvidable en cada compra.
        </p>
      </div>
    </div>
  );
}
